// extracted by mini-css-extract-plugin
export default {"searchContentWrapper":"styles_searchContentWrapper__2e0pO","emptySpace":"styles_emptySpace__zCZcE"};